export default window.Vue;
